// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'column-delete';

export const Component = () => (
  <g stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M1 1.03v16m16-16v16m-6.4-8.001H17m-16 0h6.4' />
    <path fill='none' d='M13.268 6.362 10.6 9.03l2.667 2.666M4.734 6.362 7.401 9.03l-2.667 2.666' />
  </g>
);

export const viewBox = '0 0 18 18';
